export const SIDEBAR = {
  WIDTH: 280,
};

export const HEADER = {
  H_DESKTOP: 80,
};
